import service from '../services';
import jwt from 'jsonwebtoken';

export function obterDadosUsuarioLogado(idEmpresa, idUsuario) {
  try {
    const res = service
      .post('Usuario', 'buscarUsuario', {
        idEmpresa,
        idUsuario,
      })
      .catch((error) => console.error(error));

    return res;
  } catch (error) {
    console.error('Falha ao buscar dodos do usuário corrente');
  }
}

export function verificaUsuarioAdmin() {
  const token = localStorage.getItem('user-token');
  if (token) {
    const decoded = jwt.decode(token);
    if (decoded.nomePerfil == 'Super User') return true;
  }
}
